(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anua-community-proof"] && !Shopify.designMode) return;
  try {
    
class AnuaCommunityProofSlider extends HTMLElement {
  connectedCallback() {
    this.abortController?.abort();
    this.abortController = new AbortController();
    const options = { signal: this.abortController.signal };
    this.track = this.querySelector('[data-anua-community-proof-track]');
    this.previous = this.querySelector('[data-anua-community-proof-previous]');
    this.next = this.querySelector('[data-anua-community-proof-next]');
    this.previous.addEventListener('click', () => this.move(-1), options);
    this.next.addEventListener('click', () => this.move(1), options);
  }

  move(direction) {
    const card = this.track.firstElementChild;
    if (!card) return;
    const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
    const step = card.getBoundingClientRect().width + gap;
    const index = Math.round(this.track.scrollLeft / step);
    const count = this.track.children.length;
    const nextIndex = (index + direction + count) % count;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.track.scrollTo({ left: nextIndex * step, behavior: reducedMotion ? 'instant' : 'smooth' });
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }
}

if (!customElements.get('anua-community-proof-slider')) {
  customElements.define('anua-community-proof-slider', AnuaCommunityProofSlider);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["community-proof"] && !Shopify.designMode) return;
  try {
    
class CommunityProofSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-community-proof-track]');
    this.previous = this.querySelector('[data-community-proof-previous]');
    this.next = this.querySelector('[data-community-proof-next]');
    this.cards = Array.from(this.track.children);
    this.cloneCount = Math.min(3, this.cards.length);
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.isResetting = false;

    if (this.cloneCount < 1) return;

    this.cards.slice(-this.cloneCount).reverse().forEach((card) => {
      const clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      this.track.prepend(clone);
    });

    this.cards.slice(0, this.cloneCount).forEach((card) => {
      const clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      this.track.append(clone);
    });

    this.previous.addEventListener('click', () => this.move(-1));
    this.next.addEventListener('click', () => this.move(1));
    this.track.addEventListener('scroll', () => this.handleLoop(), { passive: true });
    this.addEventListener('mouseenter', () => this.pause());
    this.addEventListener('mouseleave', () => this.play());
    this.addEventListener('focusin', () => this.pause());
    this.addEventListener('focusout', () => this.play());
    window.addEventListener('resize', () => this.positionAtStart());
    this.positionAtStart();
    this.play();
  }

  stepSize() {
    const card = this.track.querySelector('.community-proof__quote');
    const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
    return card ? card.getBoundingClientRect().width + gap : 0;
  }

  positionAtStart() {
    const step = this.stepSize();
    if (step) this.track.scrollLeft = step * this.cloneCount;
  }

  move(direction) {
    const step = this.stepSize();
    if (step) this.track.scrollBy({ left: direction * step, behavior: this.reducedMotion ? 'auto' : 'smooth' });
  }

  handleLoop() {
    if (this.isResetting) return;
    const step = this.stepSize();
    const originalWidth = step * this.cards.length;
    const start = step * this.cloneCount;
    if (!step || !originalWidth) return;

    if (this.track.scrollLeft <= step * .25) {
      this.resetTo(this.track.scrollLeft + originalWidth);
    } else if (this.track.scrollLeft >= start + originalWidth - step * .25) {
      this.resetTo(this.track.scrollLeft - originalWidth);
    }
  }

  resetTo(position) {
    this.isResetting = true;
    this.track.scrollLeft = position;
    requestAnimationFrame(() => {
      this.isResetting = false;
    });
  }

  play() {
    if (this.reducedMotion || this.timer) return;
    this.timer = window.setInterval(() => this.move(1), 3000);
  }

  pause() {
    if (!this.timer) return;
    window.clearInterval(this.timer);
    this.timer = null;
  }

  disconnectedCallback() {
    this.pause();
  }
}

if (!customElements.get('community-proof-slider')) {
  customElements.define('community-proof-slider', CommunityProofSlider);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
